import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoMultiColumnComboBoxMixin from './KendoMultiColumnComboBoxMixin'

export default {
    name: 'kendo-multicolumncombobox',
    mixins: [ KendoMultiColumnComboBoxMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h('input', [
            this.$slots['kendo-datasource'],
            defaultSlot
        ])
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoMultiColumnComboBox/index.js